module.exports = __webpack_public_path__ + "static/cat-79f1a6a717cdc49579ee0153e02e6c84.png";